import ApplicationDetail from '@/pages/application/detail/ApplicationDetail.vue';
import type { RouteRecordRaw } from 'vue-router';
import { TravelerLayout, HasNavigationLayout } from '@/pages/_layout';
import { FUNNEL_EVENTS } from '@/shared/lib/analytics';

const as = 'application';
const prefix = `/application`;

export const applicationRoutes: Array<RouteRecordRaw> = [
    {
        path: `${prefix}/guide`,
        name: `${as}.guide`,
        component: () => import('@/pages/application-guide/ApplicationGuidePage.vue'),
        meta: {
            title: 'エアラゲッジ 申込案内',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.GUIDE_VIEW,
        },
    },
    {
        path: `${prefix}/input`,
        name: `${as}.input`,
        component: () => import('@/pages/application-input/ApplicationInputPage.vue'),
        meta: {
            title: 'エアラゲッジ 配送予約入力',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.INPUT_VIEW,
        },
    },
    {
        path: `${prefix}/confirmation`,
        name: `${as}.confirmation`,
        component: () => import('@/pages/application-confirmation/ApplicationConfirmationPage.vue'),
        meta: {
            title: 'エアラゲッジ 配送予約確認',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.CONFIRMATION_VIEW,
        },
    },
    {
        path: `${prefix}/complete/:applicationId`,
        name: `${as}.complete`,
        component: () => import('@/pages/application-complete/ApplicationCompletePage.vue'),
        meta: {
            title: '予約完了',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.COMPLETE_VIEW,
        },
    },
    {
        path: `${prefix}/server-error`,
        name: `${as}.server-error`,
        component: () => import('@/pages/application-server-error/ApplicationServerErrorPage.vue'),
        meta: {
            title: 'メンテナンス中',
            requiresAuth: false,
            layout: TravelerLayout,
        },
    },
    {
        path: `${prefix}/service-end`,
        name: `${as}.service-end`,
        component: () => import('@/pages/service-end-announce/ServiceEndAnnouncePage.vue'),
        props: (route) => ({
            hotelJapaneseName: route.query.hotelJapaneseName as string | undefined,
            hotelEnglishName: route.query.hotelEnglishName as string | undefined,
            hotelLpUrl: route.query.hotelLpUrl as string | undefined,
        }),
        meta: {
            title: 'サービス終了のご案内',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
        },
    },
    {
        path: `${prefix}/edit/:applicationId`,
        name: `${as}.edit`,
        component: () => import('@/pages/application-edit/ApplicationEditPage.vue'),
        meta: {
            title: 'エアラゲッジ 配送予約編集',
            requiresAuth: false,
            layout: TravelerLayout,
            trackGA4: true,
        },
    },
    {
        path: '/applications/:applicationId',
        name: 'application-detail',
        component: ApplicationDetail,
        props: (route) => ({
            applicationId: route.params.applicationId,
        }),
        meta: {
            title: 'ユーザー詳細',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/traveler-consent/:applicationId',
        name: `${as}.traveler-consent`,
        component: () => import('@/pages/traveler-consent/TravelerConsentPage.vue'),
        props: true,
        meta: {
            title: '旅行者荷物預かり同意サイン',
            requiresAuth: true,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.CONSENT_VIEW,
        },
    },
    {
        path: '/traveler-handover/:applicationId',
        name: `${as}.traveler-handover`,
        component: () => import('@/pages/traveler-handover/TravelerHandoverPage.vue'),
        props: true,
        meta: {
            title: 'エアラゲッジ 荷物受け渡し',
            requiresAuth: true,
            layout: TravelerLayout,
            trackGA4: true,
            ga4Event: FUNNEL_EVENTS.HANDOVER_VIEW,
        },
    },
];
